import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { UserService } from './../../services/user/user.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import * as _ from 'lodash';

@Component({
  selector: 'hg-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  constructor(
    private _userService: UserService,
    public currentUserService: CurrentUserService,
    private location: Location,
    private _gaSvc: GoogleAnalyticsService,
    private _redirectUrl: RedirctUrlService,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService) { }

  private userObs: Subscription;
  subselection: string;
  selected: string;
  currentUser: string;
  public notifications: any[] = [];
  public entitlements = [];

  async ngOnInit() {
    this.currentUserService.getUser().then(user => {
      let entitlementObs = _.get(user, 'role.entitlements', []);
      this.entitlements = entitlementObs.map(entitlemtnt => entitlemtnt.code).reduce((a, b) => (a[b] = true, a), {});

      this.currentUser = user.firstname;
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {

  }

  public checkPrivilege(entitlement) {
    if (!this.entitlements || !entitlement) return false;
    return this.entitlements[entitlement];
  }

  get role(): string {
    if (this.currentUserService.user && this.currentUserService.user.role) {
      return this.currentUserService.user.role.code;
    }
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

  async gaAnalytics(name: string){
    const user = await this.currentUserService.user;
    this._gaSvc.register(`User Admin`, `View Carrier ${name}`, user.username);
  }

}
